import React from 'react';
import styles from './PresentationHero.module.css';

const PresentationHero = ({
  badge,
  scriptTitle,
  boldTitle,
  descHeading,
  descParagraphs,
  images,
}) => (
  <section className={styles.heroSection}>
    <div className={styles.inner}>
      <div className={styles.grid}>
        <div className={styles.copyCol}>
          <span className={styles.badge}>{badge}</span>

          <div className={styles.titleBlock}>
            <span className={styles.eyebrow}>{scriptTitle}</span>
            <h1 className={styles.title}>{boldTitle}</h1>
          </div>

          <p className={styles.kicker}>{descHeading}</p>

          <div className={styles.bodyCopy}>
            {descParagraphs.slice(0, 2).map((paragraph, index) => (
              <p key={index} className={styles.paragraph}>
                {paragraph}
              </p>
            ))}
          </div>
        </div>

        <div className={styles.visualCol}>
          <div className={styles.imageStack}>
            {images[0] && (
              <div className={styles.primaryFrame}>
                <img src={images[0].src} alt={images[0].alt} />
              </div>
            )}
            {images[1] && (
              <div className={styles.secondaryFrame}>
                <img src={images[1].src} alt={images[1].alt} />
              </div>
            )}
            <span className={styles.accentBar} aria-hidden="true" />
            <span className={styles.accentCorner} aria-hidden="true" />
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default PresentationHero;
